export interface stateType {
  headerInfo: {
    'c-id': string
    'c-meta': string
  }
  techListShowFields: string[]
  examMonthlyShowFields: string[]
  merchantExamMonthlyShowFields: string[]
  examMonthlyStatisticsShowFields: string[]
}

export const state: () => stateType = () => {
  return {
    headerInfo: {
      'c-id': '',
      'c-meta': ''
    },
    techListShowFields: [],
    examMonthlyShowFields: [],
    merchantExamMonthlyShowFields: [],
    examMonthlyStatisticsShowFields: []
  }
}
